import type {
    AccountAddressesErrorResponse,
    AccountAddressesSuccessResponse,
    AddAddressRequest,
    RemoveAddressResponse,
} from '@libs/common-next';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export async function getAddresses() {
    const url = CWEA_ENDPOINTS.addresses.getAddresses;
    return await cweaClient.get<AccountAddressesSuccessResponse[]>(url, { useOldFetch: true });
}

export async function addAddress(body: AddAddressRequest) {
    const url = CWEA_ENDPOINTS.addresses.addAddress;

    const response = await cweaClient.post<
        AccountAddressesSuccessResponse | AccountAddressesErrorResponse | null,
        AddAddressRequest
    >(url, {
        body,
        additionalSuccessCodes: [409, 400],
    });

    if (response instanceof Error || (response && 'parsedResponse' in response)) {
        throw response;
    }

    return response;
}

export async function updateAddress(addressId: number, body: AddAddressRequest) {
    const url = CWEA_ENDPOINTS.addresses.updateAddress(addressId);

    const response = await cweaClient.put<
        AccountAddressesSuccessResponse | AccountAddressesErrorResponse | null,
        AddAddressRequest
    >(url, {
        body,
    });

    if (response instanceof Error || (response && 'parsedResponse' in response)) {
        throw response;
    }

    return response;
}

export async function removeAddress(addressId: number) {
    const url = CWEA_ENDPOINTS.addresses.removeAddress(addressId);

    const response = await cweaClient.delete<RemoveAddressResponse | null>(url, {
        additionalSuccessCodes: [400, 401, 404, 500],
    });

    if (response instanceof Error || (response && 'parsedResponse' in response)) {
        throw response;
    }

    return response;
}
